import React from 'react'

import { HideWhenBlocked } from './../../Containers/UIBlock/HideWhenBlocked'
import { LayoutDashboard } from './../../Components/Layout/Dashboard'
import { CampaignsWrapper } from './../../Components/Campaigns/CampaignsWrapper'
import { PageTitle } from './../../Components/PageTitle'
import { authorization } from './../../Module/Auth/Auth'
import CampaignsIcon from './../../Assets/Images/icons/campaigns'
import DataFetchingComponent from './../../Components/DataFetchingComponent'
import FilterAndPaginationComponent from './../../Components/FilterAndPaginationComponent'
import CampaignCard from '../../Components/Campaigns/CampaignCard'
import SubmitButton from 'Components/Form/SubmitButton'
import { Grid } from '@material-ui/core'
import { CAMPAIGN_SORTING_OPTIONS } from './utils'
import StyledBreadcrumbs from '../../Components/StyledBreadcrumbs'

const View = props => {
  var { filters, fetchData, setListView, listView, ...otherProps } = props

  return (
    <HideWhenBlocked>
      <LayoutDashboard>
        <CampaignsWrapper>
          <StyledBreadcrumbs
            icon={<CampaignsIcon style={{ width: 16 }} />}
            breadcrumbs={[{ label: 'Campaigns' }]}
          />
          <PageTitle>Campaigns</PageTitle>
          {authorization.isAdmin() && (
            <SubmitButton
              value="Create campaign"
              id="create-campaign-button"
              className="create-campaign"
              hideSvg={true}
              onClick={() => props.history.push(`${props.match.url}/create`)}
              cypress_id="create-campaign-button"
            />
          )}
          <DataFetchingComponent
            filters={filters}
            fetchData={fetchData}
            showSearch={false}
            Component={props => <ContentView {...props} {...otherProps} />}
          />
        </CampaignsWrapper>
      </LayoutDashboard>
    </HideWhenBlocked>
  )
}

export default View

const ContentView = props => {
  const isCityManagerAssistant = authorization.isCityManagerAssistant()

  const getViewPath = id =>
    isCityManagerAssistant
      ? `${props.match.url}/${id}/live-map`
      : `${props.match.url}/${id}/dashboard`

  return (
    <FilterAndPaginationComponent
      {...props}
      isComponentTable={false}
      rowsPerPageOptions={[10, 20, 50, 100]}
      sortingOptions={CAMPAIGN_SORTING_OPTIONS}
      Component={({ data, sortByValue, setSelectedSort }) => {
        sortByValue && setSelectedSort(sortByValue)
        return (
          <Grid container spacing={3}>
            {data.map(campaign => {
              return (
                <Grid item xs={12} md={6} lg={3} key={'' + campaign.id}>
                  <CampaignCard
                    campaignId={campaign.id || ''}
                    title={campaign.name || ''}
                    subTitle={campaign.client}
                    isSelfServe={campaign.isSelfServe}
                    description={
                      <div>
                        Number of cities{' '}
                        <span className="number">{campaign.totalCities}</span>
                      </div>
                    }
                    footer={campaign.type}
                    img={campaign.clientLogo}
                    viewPath={getViewPath(campaign.id)}
                    editPath={
                      authorization.isClient()
                        ? ''
                        : `${props.match.url}/${campaign.id}/edit`
                    }
                    onClick={() => {
                      if (isCityManagerAssistant) {
                        props.history.push(
                          `${props.match.url}/${campaign.id}/live-map`,
                        )
                      } else {
                        props.history.push(
                          `${props.match.url}/${
                            campaign.id
                          }/dashboard/overview`,
                        )
                      }
                    }}
                    clickable
                    status={campaign.status}
                    lastConversionDate={campaign.lastConversionDate}
                    campaignTimeRange={campaign.campaignTimeRange}
                    cypress_id="campaigns-page-campaign-card"
                  />
                </Grid>
              )
            })}
          </Grid>
        )
      }}
    />
  )
}
